export function createTimeZoneLabel(timeZoneString) {
    return timeZoneString;
}